document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined' || !document.querySelector('.mySwiper')) return;
  const swiper = new Swiper('.mySwiper', {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
});

function setVh() {
  // Calcule la vraie hauteur du viewport
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// On appelle la fonction au chargement
setVh();

// On recalcule à chaque changement de taille de fenêtre (ex: rotation d'écran)
window.addEventListener('resize', setVh);
